/**
 * FilterEmptyState — friendly empty panel shown when Industry / Region /
 * Company Size filters narrow the dataset down to zero matching orgs.
 *
 * Used in place of blank charts and empty tables on benchmarking
 * surfaces so the user knows *why* they're seeing nothing (and has a
 * one-click escape hatch).
 */
import React from 'react';
import { Filter } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

export function FilterEmptyState({
  onClear,
  title = 'No organizations match the current filters',
  hint = 'Try removing one of the Industry, Region, or Company Size filters.',
  testId = 'filter-empty-state',
}) {
  return (
    <Card data-testid={testId}>
      <CardContent className="flex flex-col items-center gap-3 py-12 text-center">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-slate-500">
          <Filter className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-slate-800">{title}</p>
          <p className="text-xs text-slate-500 max-w-sm">{hint}</p>
        </div>
        {onClear && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onClear}
            data-testid={`${testId}-clear`}
          >
            Clear filters
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

export default FilterEmptyState;
